import React, { Component } from "react";
import AdminBreadcrumb from "../Common/Breadcrumb";
import Aux from "../../../../hoc/Auxilliary";
import { downloadLmsPackage, getModules } from "../../../../data-service-admin";
import { ToastContainer } from "react-toastr";
import Spinner from "../../../User/Common/Spinner/Spinner";
import { showToastMessage, showErrorToastMessage } from "../../../../utilities";
import { API_URL } from "../../../../constants";
//Before GDPR
class AdminIntegration extends Component {
  state = {
    showSpinner: false,
    searchTerm: "",
    errorMessage: "",
    modules: [],
    selectedmodule: {}
  };

  componentDidMount() {
    this.getModulesFromService();
  }

  getModulesFromService() {
    this.showSpinner(true);
    let arrModules = [];
    getModules()
      .then(response => {
        this.showSpinner(false);
        for (let module of response.data.filter(d => d.IsDelete === false)) {
          arrModules.push(
            <option key={module.Id} value={module.Id}>
              {module.Name}
            </option>
          );
        }
        this.setState({ modules: arrModules });
      })
      .catch(error => {
        this.showSpinner(false);
        console.log(error);
        this.showErrorMessage(error);
      });
  }
  download() {
    const moduleid = this.refs["selModule"].value;
    this.showSpinner(true);
    downloadLmsPackage(moduleid)
      .then(response => {
        this.showSpinner(false);
        this.showSuccessMessage("Packaging! Download will begin shortly...");
        window.open(API_URL + "/download/downloadFile?file=" + response.data, "_blank");
      })
      .catch(error => {
        this.showSpinner(false);
        this.showErrorMessage(error);
      });
  }
  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }
  showSuccessMessage(item) {
    showToastMessage("success", "Download", item, this, "toastr1");
  }
  showErrorMessage(error) {
    showErrorToastMessage(this, "toastr1", error);
  }
  render() {
    return (
      <Aux>
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        <h1 className="page-header">LMS Integration</h1>
        <AdminBreadcrumb data={[{ name: "Home", link: "/admin/modules/" }, { name: "Integration" }]} />
        <div className="form-group">
          <label>Module:</label>
          <select ref="selModule" className="form-control">
            {this.state.modules}
          </select>
        </div>
        <a className="btn btn-default" onClick={() => this.download()}>
          Click here to download the SCORM package
        </a>
      </Aux>
    );
  }
}

export default AdminIntegration;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Integration/Integration.js